import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { DEFAULT_PAGINATION_STATE } from './pagination.service.config';
import { PaginationModel, PaginationState } from './pagination.types';

@Injectable({
  providedIn: 'root',
})
export class PaginationService {
  private paginationState$ = new BehaviorSubject<PaginationModel>(DEFAULT_PAGINATION_STATE);

  getPaginationState(pageSize: number): Observable<PaginationModel> {
    this.paginationState$.next({
      ...this.getPagination(), pageSize,
    });
    return this.paginationState$.asObservable();
  }

  getPagination(): PaginationModel {
    return this.paginationState$.getValue();
  }

  resetPaginationState(pageSize: number): void {
    this.paginationState$.next({
      ...DEFAULT_PAGINATION_STATE, pageSize,
    });
  }

  setPaginationState(pagination: Partial<PaginationModel>): void {
    this.paginationState$.next({
      ...this.getPagination(), ...pagination,
    });
  }

  getRequestPaginationModel(): PaginationState {
    const pagination = this.getPagination();
    return {
      pagination: {
        from: pagination.initialPage * pagination.pageSize,
        to: ((pagination.currentPage + 1) * pagination.pageSize) - 1,
      },
    };
  }
}
